import React, { Fragment } from 'react';

import { subscriber_profile_path } from '../../routes';
import Pagination, { PaginationType } from '../BaseUI/Pagination';
import NoResultsMessage from '../shared/NoResultsMessage';
import ArticleOrBriefingFeedItem, { ArticleOrBriefing } from './ArticleOrBriefingFeedItem';
import { ArticleAuthors } from './AuthorsLine';
import { EntityTopic } from './EntityTopics';

export type ArticleOrBriefingDataContent = {
  entityTopics: EntityTopic[];
  authors: ArticleAuthors;
  highlightSlug?: string;
  excerpt: { short: string; long: string };
  isPro?: boolean;
  type: 'Article' | 'Briefing';
};

export type ArticleData = Record<number, ArticleOrBriefingDataContent>;

export default function Feed({
  articleData,
  articlesOrBriefings,
  commentCounts,
  paginationData,
  useLargeImage,
  username,
}: {
  articleData: ArticleData;
  articlesOrBriefings: ArticleOrBriefing[];
  commentCounts: { [key: number]: number };
  paginationData?: PaginationType;
  useLargeImage?: boolean;
  username?: string;
}) {
  const getPath = (page: number) =>
    subscriber_profile_path(username, page === 1 ? undefined : page);

  return (
    <div>
      {articlesOrBriefings.length > 0 ? (
        <div>
          {articlesOrBriefings.map((articleOrBriefing, i) => (
            <Fragment key={articleOrBriefing.id}>
              <ArticleOrBriefingFeedItem
                articleOrBriefing={articleOrBriefing}
                articleOrBriefingData={articleData[articleOrBriefing.id]}
                commentCount={commentCounts[articleOrBriefing.id]}
                useFeaturedLayout={(i + 1) % 4 === 0}
                useLargeImage={useLargeImage}
              />
            </Fragment>
          ))}
        </div>
      ) : (
        <NoResultsMessage />
      )}
      {paginationData?.totalPages > 1 && (
        <Pagination paginationData={paginationData} getPath={getPath} />
      )}
    </div>
  );
}
